import { Head, useForm, usePage } from '@inertiajs/react'
import { Anchor, Button, Container, Paper, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core'
import type { FormEvent } from 'react'
import type { SharedProps, SignupPageProps } from '@/types'

export default function New({ errors }: SignupPageProps) {
  const { csrf_token } = usePage<SharedProps>().props

  const { data, setData, post, processing, errors: formErrors } = useForm({
    user: {
      email: '',
      password: '',
      password_confirmation: '',
    },
    authenticity_token: csrf_token as string,
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post('/users', { preserveScroll: true })
  }

  const allErrors = {
    email: errors?.email || formErrors['user.email'],
    password: errors?.password || formErrors['user.password'],
    password_confirmation: errors?.password_confirmation || formErrors['user.password_confirmation'],
  }

  const formatError = (value: string | string[] | undefined) => {
    if (!value) return undefined
    return Array.isArray(value) ? value.join(', ') : value
  }

  return (
    <>
      <Head title="Sign up" />

      <Container size="xs" py={80}>
        <Paper component="form" onSubmit={handleSubmit} p="xl" radius="xl" shadow="md" withBorder>
          <Stack gap="lg">
            <Stack gap={4}>
              <Title order={2}>Create an account</Title>
              <Text c="dimmed">Get started with your new workspace.</Text>
            </Stack>

            <TextInput
              id="email"
              type="email"
              label="Email"
              autoComplete="email"
              value={data.user.email}
              onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
              error={formatError(allErrors.email)}
            />

            <PasswordInput
              id="password"
              label="Password"
              description="Minimum 6 characters"
              autoComplete="new-password"
              value={data.user.password}
              onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
              error={formatError(allErrors.password)}
            />

            <PasswordInput
              id="password_confirmation"
              label="Confirm password"
              autoComplete="new-password"
              value={data.user.password_confirmation}
              onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
              error={formatError(allErrors.password_confirmation)}
            />

            <Button type="submit" loading={processing}>
              Create account
            </Button>

            <Text c="dimmed" size="sm" ta="center">
              Already have an account?{' '}
              <Anchor href="/users/sign_in">Sign in</Anchor>
            </Text>
          </Stack>
        </Paper>
      </Container>
    </>
  )
}
